import { useSellerPageContext } from "../../context-state/SellerPageContext.jsx";
import useResponsive from "../../hooks/minimal/useResponsive.jsx";
import { Stack, Card } from '@mui/material'
import Image from "../../components/minimal/image/index.jsx";
import { isEmbedMode } from "../../utils/iframe";


const SellerJumbotron = () => {
    const { accountContext } = useSellerPageContext()
    const { account } = accountContext
    const isMobile = useResponsive('down', 'sm');

    // Hide jumbotron in embed mode
    if (isEmbedMode()) {
        return null;
    }

    if (!account) {
        return null
    }

    let { design } = account
    design = design ? design : {}
    const backgroundImageOverlay = design.sellerPageBackgroundImageOverlay ? `linear-gradient(${design.sellerPageBackgroundImageOverlay}, ${design.sellerPageBackgroundImageOverlay})` : "linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.3))"
    
    return (
        <Stack sx={{ height: isMobile ? "40vh" : "50vh", position: "relative", width: "100%", backgroundImage: `${backgroundImageOverlay}, url(${isMobile && design.imageBGMobile ? design.imageBGMobile : design.backgroundImage})`, backgroundPosition: "center", backgroundSize: "cover" }}>
            <Stack sx={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)" }}>
                {design.profileImage && !design.profileImageIsLogo && <Card sx={{ backgroundColor: "#fff", borderRadius: "50%" }}>
                    <Image
                        disabledEffect={true}
                        sx={{ width: isMobile ? "120px" : "200px", height: isMobile ? "120px" : "200px", borderRadius: "50%" }}
                        src={design.profileImage}
                    />
                </Card>}
            </Stack>
        </Stack>
    )
}

export default SellerJumbotron